import { useEffect, useState } from "react";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";
import dayjs from "dayjs";

const FaithLeaderWithdraw = () => {
  const [status, setStatus] = useState("pending");
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rejectFor, setRejectFor] = useState(null);
  const [rejectReason, setRejectReason] = useState("");

  const fetchData = () => {
    setLoading(true);
    apiInstanceFetch
      .get(`faithWithdrawRequest/adminList?status=${status}`)
      .then((res) => {
        if (res?.status) {
          setRows(res.withdrawals || []);
          setTotal(res.total || 0);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [status]);

  const handleDecision = (id, decision, reason) => {
    apiInstanceFetch
      .post(`faithWithdrawRequest/adminDecision`, { id, decision, reason: reason || "" })
      .then((res) => {
        if (res?.status) {
          setToast("success", res.message || "Decision saved.");
          setRows((prev) => prev.filter((r) => r._id !== id));
        } else {
          setToast("error", res?.message || "Failed.");
        }
      })
      .catch(() => setToast("error", "Decision failed."));
  };

  const confirmReject = () => {
    if (!rejectFor) return;
    handleDecision(rejectFor, "reject", rejectReason.trim());
    setRejectFor(null);
    setRejectReason("");
  };

  return (
    <div className="userMain">
      <div className="tableMain mt-3">
        <div className="d-flex justify-content-between align-items-center px-3 pt-2 pb-2 flex-wrap">
          <div>
            <h4>Faith Leader Withdrawals</h4>
            <small className="text-secondary">Review and release donation withdrawals manually.</small>
          </div>
          <div className="d-flex gap-2">
            {["pending", "approved", "rejected"].map((s) => (
              <button
                key={s}
                type="button"
                className={`btn btn-sm ${status === s ? "btn-primary" : "btn-outline-secondary"} text-capitalize`}
                onClick={() => setStatus(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        <div className="px-3 table-responsive">
          <table className="table table-hover align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Leader</th>
                <th>Organisation</th>
                <th>Amount</th>
                <th>USD Equiv.</th>
                <th>Method</th>
                <th>Account / Number</th>
                <th>Requested</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="9" className="text-center text-secondary py-4">Loading…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan="9" className="text-center text-secondary py-4">No {status} requests.</td></tr>
              ) : (
                rows.map((w, idx) => {
                  const user = w.leaderUserId || {};
                  const leader = w.leaderId || {};
                  const pd = w.paymentDetails || {};
                  const accountDisplay = pd.method === "bank"
                    ? `${pd.bankName || ""} • ${pd.accountNumber || ""}`
                    : `${pd.mobileNetwork || ""} • ${pd.mobileNumber || ""}`;
                  return (
                    <tr key={w._id}>
                      <td>{idx + 1}</td>
                      <td>{user.firstName || ""} {user.lastName || ""}<br/><small className="text-secondary">{user.uniqueId || ""}</small></td>
                      <td>{leader.organisationName || "—"}</td>
                      <td>{w.currency} {w.amount?.toFixed?.(2) || w.amount}</td>
                      <td>
                        ${(w.usdEquivalent || 0).toFixed(2)}
                        {w.netPayableUsd ? (
                          <div style={{ fontSize: "12px", opacity: 0.75 }}>pay ${w.netPayableUsd.toFixed(2)} (1% fee)</div>
                        ) : null}
                      </td>
                      <td className="text-capitalize">{pd.method || "—"}</td>
                      <td><small>{pd.accountName || "—"}<br/>{accountDisplay}</small></td>
                      <td><small>{dayjs(w.createdAt).format("DD MMM YYYY, HH:mm")}</small></td>
                      <td>
                        {status === "pending" ? (
                          <div className="d-flex gap-1">
                            <button type="button" className="btn btn-sm btn-success" onClick={() => handleDecision(w._id, "approve")}>Approve</button>
                            <button type="button" className="btn btn-sm btn-danger" onClick={() => { setRejectFor(w._id); setRejectReason(""); }}>Reject</button>
                          </div>
                        ) : status === "rejected" ? (
                          <small className="text-secondary">{w.reason || "No reason"}</small>
                        ) : (
                          <span className="badge bg-success">Approved</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
          <div className="text-secondary px-2 py-1">Total: {total}</div>
        </div>
      </div>

      {rejectFor && (
        <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.6)" }} onClick={() => setRejectFor(null)}>
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject withdrawal</h5>
                <button type="button" className="btn-close" onClick={() => setRejectFor(null)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Reason (optional)</label>
                <textarea className="form-control" rows="3" value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} placeholder="Will be sent to the leader."></textarea>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setRejectFor(null)}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={confirmReject}>Confirm reject</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FaithLeaderWithdraw;
